"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var TapeMeasure = function TapeMeasure(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'original' : _ref$size;
  var iconSize = size === 'original' ? 'width="28.16" height="21.64"' : 'width="100%"';
  var title = 'Tape Measure Icon';
  return "\n    <svg role=\"img\" aria-label=\"".concat(title, "\" xmlns=\"http://www.w3.org/2000/svg\" ").concat(iconSize, " viewBox=\"0 0 28.16 21.64\">\n      <title>").concat(title, "</title>\n      <path\n        d=\"M10.79,14A3.22,3.22,0,1,1,14,10.82,3.22,3.22,0,0,1,10.79,14m0-8.59a5.37,5.37,0,1,0,5.37,5.37,5.38,5.38,0,0,0-5.37-5.37\"\n        style=\"fill: ").concat(color, "; fill-rule: evenodd;\"\n      />\n      <path\n        d=\"M2.15,19.49V10.82a8.65,8.65,0,1,1,17.29,0v8.67ZM26,17v2.54H21.59V10.82a10.82,10.82,0,0,0-2.21-6.56l.75-.76L17.59,1l-.84.85a10.68,10.68,0,0,0-6-1.8A10.8,10.8,0,0,0,0,10.82V21.64H28.16V17Z\"\n        style=\"fill: ").concat(color, "; fill-rule: evenodd;\"\n      />\n    </svg>\n  ");
};

var _default = TapeMeasure;
exports["default"] = _default;